import { render, staticRenderFns } from "./NavigationProfile.vue?vue&type=template&id=88c57d1c&scoped=true"
import script from "./NavigationProfile.vue?vue&type=script&lang=js"
export * from "./NavigationProfile.vue?vue&type=script&lang=js"
import style0 from "./NavigationProfile.vue?vue&type=style&index=0&id=88c57d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c57d1c",
  null
  
)

export default component.exports